import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { SearchIcon, UploadIcon } from '@deliveryhero/armor-icons';
import { getPropsBlocker } from '../../../utils';

var searchIconContainerStyle = function searchIconContainerStyle(_ref) {
  var SearchIconTheme = _ref.theme.componentOverrides.SearchIcon;
  return SearchIconTheme.SearchIconContainer.base;
};

export var SearchIconContainer = styled.div.withConfig(getPropsBlocker())(_templateObject(), searchIconContainerStyle);

var loadingIconIconStyle = function loadingIconIconStyle(_ref2) {
  var SearchIconTheme = _ref2.theme.componentOverrides.SearchIcon;
  return SearchIconTheme.LoadingIcon.base;
};

export var SearchInputLoadingIcon = styled(UploadIcon).withConfig(getPropsBlocker({}, false))(_templateObject2(), loadingIconIconStyle);

var searchIconStyle = function searchIconStyle(_ref3) {
  var SearchIconTheme = _ref3.theme.componentOverrides.SearchIcon;
  return SearchIconTheme.SearchIcon.base;
};

export var SearchInputSearchIcon = styled(SearchIcon).withConfig(getPropsBlocker({}, false))(_templateObject3(), searchIconStyle);